<template>

	<div class="card" v-on:mouseenter="isImageHidden = true" v-on:mouseleave="isImageHidden = false" v-on:click="$emit('click', template)">


		<!------------------------- Card Image ------------------------->

		<div v-show="!isImageHidden">
			<div class="card-top">

				<!---- Tag on top of the image
				<div v-if="'FormMarketplaceCategory' in template && template.FormMarketplaceCategory" class="position-absolute ml-2 mt-1">
					<div class="badge bg-purple text-white">
						{{template.FormMarketplaceCategory.name}}
					</div>
				</div>
				---->

				<div class="d-flex justify-content-center">
					<img v-if="imageUrl" class="card-img-top" :src="imageUrl" alt="Card image cap">
					<div v-else class="card-img-top"></div>
				</div>

			</div>

		</div>


		<!------------------------- Card Text ------------------------->

		<div class="card-body">

			<h5 class="card-title clamped" :class="{'clamped-2': !isImageHidden, 'clamped-4': isImageHidden}">
				{{template.title}}
			</h5>

			<div class="card-text text-muted mb-1 clamped" :class="{'clamped-2': !isImageHidden, 'clamped-5': isImageHidden}">
				{{template.description}}
			</div>

			<div v-if="isImageHidden" class="mt-2">
				<div v-if="'FormMarketplaceCategory' in template && template.FormMarketplaceCategory">
					<div class="badge bg-purple text-white">
						{{template.FormMarketplaceCategory.name}}
					</div>
				</div>
			</div>

		</div>

	</div>
</template>

<script>

import FormToolbar from "@/pages/forms/FormToolbar";
import Field from "@/components/Field"
import SearchBar from "@/components/SearchBar"

export default {
	name: "FormMarketplaceTemplate",
	props: [
		"template"
	],
	data() {
		return {
			isImageHidden: false
		}
	},

	computed: {

		imageUrl() {
			if ('UploadImage' in this.template && this.template.UploadImage)
				return this.apiRoot+'resources/images/'+this.$store.sessionToken+'/'+this.template.UploadImage.thumb_filename
			return false
		}
	}
}
</script>

<style type="text/css" scoped>

.card:hover {
	cursor: pointer;
}

.card {
	height: 280px;
	width: 260px;
	min-width: 200px;
	margin: 15px 15px;
}

.card-top {
	border-top-left-radius: 9px;
	border-top-right-radius: 9px;
	background-color: var(--background-menus);
}

.card-img-top {
	width: 100%;
	height: 135px;
	object-fit: cover;
	border-top-left-radius: 9px;
	border-top-right-radius: 9px;
	border-bottom: var(--background-menus) solid 1px;
}

.bg-purple {
	background-color: var(--brand-primary-color);
}

.clamped {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	overflow: hidden;
}

.clamped-2 {
	-webkit-line-clamp: 2;
}

.clamped-4 {
	-webkit-line-clamp: 4;
}

.clamped-5 {
	-webkit-line-clamp: 5;
}

@media (max-width: 600px) {

	.card {
		width: 90%;
	}

}

</style>
